import { List } from 'immutable';
import Invoice from '../../../interfaces/output/invoiceOut';
import { ensure } from '../../../utils/arrayUtils';
import LanguageUtils from '../../../utils/LanguageUtils';
import ValidationModel from '../../../utils/validationModel';
import ValidationUtils from '../../../utils/validationUtils';

const messages = {
    requiredFields: LanguageUtils.createMessage('Validation error general')
};

export default class InvoiceStep1Validation extends ValidationUtils {

    static validateOrderForm(invoice: Invoice): ValidationModel {
        const validationModel = {
            validationMessages: List(),
            isValid: true
        } as ValidationModel;

        const { invoiceNumber,
            invoiceType
        } = invoice;

        const requiredFields =
            this.validateInputNumber(invoiceNumber) &&
            this.validateInputNumber(invoiceType?.id);

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        return validationModel;
    }
}
